import React from "react";
import { Stack, Title, Paper, Group } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
  ConnectPayments,
  ConnectPayoutsList,
  ConnectBalances,
  ConnectNotificationBanner,
  ConnectDisputesList,
} from "@stripe/react-connect-js";

function Overview() {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Stack spacing="md" p="md">
      <ConnectNotificationBanner
        collectionOptions={{
          fields: "eventually_due",
          futureRequirements: "include",
        }}
      />
      <Paper p="md" withBorder gap="md">
        <Title order={3} mb="md">
          Balance Summary
        </Title>
        <ConnectBalances />
      </Paper>

      {!isMobile ? (
        <Group grow align="flex-start">
          <Paper p="md" withBorder>
            <Title order={3} mb="md">
              Recent Payments
            </Title>
            <ConnectPayments />
          </Paper>

          <Paper p="md" withBorder>
            <Title order={3} mb="md">
              Payout History
            </Title>
            <ConnectPayoutsList />
          </Paper>
        </Group>
      ) : (
        <Stack spacing="md">
          <Paper p="md" withBorder>
            <Title order={3} mb="md">
              Recent Payments
            </Title>
            <ConnectPayments />
          </Paper>

          <Paper p="md" withBorder>
            <Title order={3} mb="md">
              Payout History
            </Title>
            <ConnectPayoutsList />
          </Paper>
        </Stack>
      )}

      <Paper p="md" withBorder gap="md">
        <Title order={3} mb="md">
          Disputes
        </Title>
        <ConnectDisputesList />
      </Paper>
    </Stack>
  );
}

export default Overview;
